import React, { useState } from "react";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { TiTick } from "react-icons/ti";
import Slider from "../slider/Slider";
import useOutsideClick from "../../hooks/useOutsideClick";

type VehicleSidebarProps = {
  amount: number;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleAmountChange: (e: any) => void;
  handleOptionSelect: (e: string) => void;
  brandSelect: string[];
  handleCarTypeSelect: (e: string) => void;
  handleCarCapacitySelect: (e: number) => void;
  carTypes: string[];
  carCapacity: {
    [key: number]: number;
  };
  selectedBrand: string;
  selectedCarType: string[];
  selectedCarCapacity: number[];

  selectedMPFC: number[];
  handleMPFCSelect: (e: number) => void;
  vehicleMPFC: { [key: number]: number };

  setIsSliderActive: React.Dispatch<React.SetStateAction<boolean>>;
  priceFilter: (min: number, max: number) => void;
  priceFilterReset: () => void;
  // Slider: any;

  minPrice: number | null;
  maxPrice: number | null;
  setMinPrice: React.Dispatch<React.SetStateAction<number | null>>;
  setMaxPrice: React.Dispatch<React.SetStateAction<number | null>>;
};

const VehicleSidebar: React.FC<VehicleSidebarProps> = ({
  amount,
  isOpen,
  setIsOpen,
  handleAmountChange,
  handleOptionSelect,
  brandSelect,
  handleCarTypeSelect,
  handleCarCapacitySelect,
  carTypes,
  carCapacity,
  selectedBrand,
  selectedCarType,
  selectedCarCapacity,
  setIsSliderActive,
  priceFilter,
  priceFilterReset,
  minPrice,
  maxPrice,
  setMinPrice,
  setMaxPrice,
  selectedMPFC,
  handleMPFCSelect,
  vehicleMPFC,

  // Slider,
}) => {
  // console.log(carCapacity);

  const brandSelectRef = React.useRef(null);

  useOutsideClick(brandSelectRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div className="w-full  hidden lg:flex lg:w-[25%] bg-white sticky top-0 z-10   py-[52px] px-[28px] flex-col gap-4 h-fit ">
      <div className="flex flex-col gap-4">
        <h1 className="text-[12px] font-semibold font-Inter text-lightGreyText uppercase">
          Price
        </h1>

        <form
          onReset={(e) => {
            e.preventDefault();
            handleOptionSelect("All Brands");
            // setMinPrice(0);
            // setMaxPrice(0);
            priceFilterReset();
          }}
          onSubmit={(e) => {
            e.preventDefault();
            if (!maxPrice || !minPrice) return;
            // handleOptionSelect("All Brands");
            priceFilter(minPrice as number, maxPrice as number);
          }}
          className="flex flex-col gap-5 justify-center items-center w-full"
        >
          <div className="w-full flex gap-5 justify-around items-center">
            <div className="flex flex-col gap-1 w-[40%]">
              <span className=" font-Jakarta font-normal text-[12px] text-[#90a3bf]">
                Min
              </span>
              <div className="font-Poppins text-[#667c8a] text-[15px] font-normal leading-5 flex gap-1 bg-[#f5f7fa] border rounded-md p-[12px] ">
                <span>$</span>

                <input
                  placeholder="0"
                  type="number"
                  name="min"
                  id="min"
                  value={minPrice as number}
                  onChange={(e) => {
                    setMinPrice(parseInt(e.target.value));
                  }}
                  required
                  className="w-[80%] outline-none border-none bg-transparent text-[#667c8a] text-[10px] font-normal leading-5"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 w-[40%]">
              <span className=" font-Jakarta font-normal text-[12px] text-[#90a3bf]">
                Max
              </span>
              <div className="font-Poppins text-[#667c8a] text-[15px] font-normal leading-5 flex gap-1 bg-[#f5f7fa] border rounded-md p-[12px] ">
                <span>$</span>

                <input
                  placeholder="1000"
                  type="number"
                  name="max"
                  id="max"
                  value={maxPrice as number}
                  onChange={(e) => {
                    setMaxPrice(parseInt(e.target.value));
                  }}
                  required
                  className="w-[80%] outline-none border-none bg-transparent text-[#667c8a] text-[10px] font-normal leading-5"
                />
              </div>
            </div>
          </div>
          <div className="w-full flex gap-5 justify-around items-center">
            <button
              type="reset"
              className="text-center font-Jakarta text-[12px] font-bold leading-4 p-[13px] text-midGreen bg-[#E5F9EF]  flex justify-center items-center border rounded-[4px] w-[40%]"
            >
              Reset
            </button>
            <button
              type="submit"
              className="text-center font-Jakarta text-[12px] font-bold leading-4 p-[13px] text-white bg-midGreen flex justify-center items-center border rounded-[4px] w-[40%]"
            >
              Apply
            </button>
          </div>
        </form>

        {/* <div className="flex flex-col-reverse gap-3 mb-4">
          <label className="mr-4 text-[#596780] text-justify text-[20px] font-semibold leading-8">
            ${amount.toFixed(2)}
          </label>
          <Slider
            min={0}
            max={1000000}
            step={0.1}
            value={amount}
            setIsSliderActive={setIsSliderActive}
            onChange={(value) => handleAmountChange(value)}
          />
        </div> */}
      </div>
      <div className="flex flex-col gap-7" ref={brandSelectRef}>
        <p className="font-Inter text-[16px] font-semibold text-[#90a3bf] ">
          Vehicle Brand
        </p>
        <div>
          <div
            className="flex justify-between border border-solid border-darkGreen rounded-md px-3 py-2 items-center cursor-pointer"
            onClick={() => setIsOpen(!isOpen)}
          >
            <p className="text-[#CDCDCD] font-Poppins  text-[13px] font-medium ">
              {selectedBrand}
            </p>
            {isOpen ? (
              <RiArrowDropUpLine size={40} color="darkGreen" />
            ) : (
              <RiArrowDropDownLine size={40} color="darkGreen" />
            )}
          </div>
          {isOpen && (
            <div className=" mt-2 py-2 w-48 bg-white border rounded-md shadow-lg">
              {brandSelect.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleOptionSelect(option)}
                  className="w-5/6 mx-auto block px-4 py-2 text-sm text-gray-800 hover:bg-lightGreen hover:rounded-lg text-left focus:outline-none"
                >
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* <div className="">
        <p className=" font-Jakarta text-[12px] font-semibold text-black ">
          TYPE
        </p>
        <div>
          {carTypes.map((option, index) => (
            <div className="" key={index}>
              <div
                className="flex  items-center cursor-pointer gap-3 w-full"
                onClick={() => handleCarTypeSelect(option)}
              >
                {selectedCarType.includes(option) ? (
                  <div className="">
                    <TiTick
                      size={40}
                      color="white"
                      className="w-4 h-4 bg-lightGreen border border-[#90a3bf] rounded-sm "
                    />
                  </div>
                ) : (
                  <div className="w-4 h-4 border border-[#90a3bf] rounded-sm"></div>
                )}
                <p className="text-[#90a3bf] font-Poppins text-[12px] font-medium leading-10 ">
                  {option}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="">
        <p className=" font-Jakarta text-[12px] font-semibold text-black ">
          MILLAGE PER FULL CHARGE
        </p>
        <div className="">
          {Object.entries(vehicleMPFC).map(([key, value]) => (
            <div className="" key={key}>
              <div
                className="flex  items-center cursor-pointer gap-3 w-full"
                onClick={(e) => {
                  e.preventDefault();
                  handleMPFCSelect(Number(key));
                }}
              >
                {selectedMPFC.includes(Number(key)) ? (
                  <div className="">
                    <TiTick
                      size={40}
                      color="white"
                      className="w-4 h-4 bg-lightGreen border border-[#90a3bf] rounded-sm "
                    />
                  </div>
                ) : (
                  <div className="w-4 h-4 border border-[#90a3bf] rounded-sm"></div>
                )}
                <p className="text-[#90a3bf] font-Poppins text-[12px] font-medium leading-10 ">
                  {`${key} - ${value} vehicle(s)`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="">
        <p className=" font-Jakarta text-[12px] font-semibold text-black ">
          CAPACITY
        </p>
        {/* <div>
          {carCapacity.map((option) => (
            <div className="" key={option}>
              <div
                className="flex  items-center cursor-pointer gap-3 w-full"
                onClick={() => handleCarCapacitySelect(option)}
              >
                {selectedCarCapacity.includes(option) ? (
                  <div className="">
                    <TiTick
                      size={40}
                      color="white"
                      className="w-4 h-4 bg-lightGreen border border-[#90a3bf] rounded-sm "
                    />
                  </div>
                ) : (
                  <div className="w-4 h-4 border border-[#90a3bf] rounded-sm"></div>
                )}
                <p className="text-[#90a3bf] font-Poppins text-[12px] font-medium leading-10 ">
                  {option}
                </p>
              </div>
            </div>
          ))}
        </div> */}
        <div className="">
          {Object.entries(carCapacity).map(([key, value]) => (
            <div className="" key={key}>
              <div
                className="flex  items-center cursor-pointer gap-3 w-full"
                onClick={(e) => {
                  e.preventDefault();
                  handleCarCapacitySelect(Number(key));
                }}
              >
                {selectedCarCapacity.includes(Number(key)) ? (
                  <div className="">
                    <TiTick
                      size={40}
                      color="white"
                      className="w-4 h-4 bg-lightGreen border border-[#90a3bf] rounded-sm "
                    />
                  </div>
                ) : (
                  <div className="w-4 h-4 border border-[#90a3bf] rounded-sm"></div>
                )}
                <p className="text-[#90a3bf] font-Poppins text-[12px] font-medium leading-10 ">
                  {`${key} - ${value} vehicle(s)`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VehicleSidebar;
